import { Routes } from "@angular/router";
import { EventSystemViewComponent } from "../event-systems/view/feature/view.component";
import { EventSystemTermsComponent } from "../event-systems/terms/feature/terms.component";
import { EventSystemListComponent } from "../event-systems/list/feature/list.component";


export const eventSystemsRoutes: Routes = [
    {
        path: 'systems',
        component: EventSystemListComponent
    },
    {
        path: 'system/:id',
        component: EventSystemViewComponent
    },
    {
        path: 'system/:id/terms',
        component: EventSystemTermsComponent,
        data: {
            sidebar: false
        }
    }
]